import Resource from '@/plugins/sdk/Resource'
import { UUID, STRING, DATETIME } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'licensee'

  static get fields () {
    return {
      id: new UUID(),
      name_display: new STRING(),
      name_full: new STRING(),
      description: new STRING(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME()
    }
  }
}
